// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { CountryTableColumn } from "../../../../Data/DataTables/Country";

// Types
import { ViewCountry } from "../../../../Types/MasterData/Country";

// Services
import {
  VIEW_COUNTRY_QUERY_KEY,
  countryService,
} from "../../../../Services/countryService";

const CountryTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_COUNTRY_QUERY_KEY,
    queryFn: countryService.getAllViewCountry,
  });

  const filteredItems: ViewCountry[] = usersResponse?.data.filter(
    (item: ViewCountry) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={CountryTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default CountryTable;
